import React, { createContext, useContext, useState } from "react";
import { MODAL_TYPES } from "../modalTypes";
import LoginModal from "../Pages/TransportIntegration/components/transportLogin";
import FeedbackModal from "../Components/modals/feedback";
import TransportSupportModal from "../Components/modals/TransportSupportModal";
// import ViewHistoryDetailsModal from "../Components/modals/ViewHistoryDetails";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [currentModal, setCurrentModal] = useState({
    type: null, // e.g., 'LOGIN', 'FEEDBACK'
    props: {}, // Any additional props for the modal
  });
  const [intendedRoute, setIntendedRoute] = useState(null);

  const showModal = (type, props = {}) => {
    setCurrentModal({ type, props });
  };

  const hideModal = () => {
    setCurrentModal({ type: null, props: {} });
  };
  const openLoginModal = () => {
    showModal(MODAL_TYPES.LOGIN);
  };
  return (
    <ModalContext.Provider
      value={{
        currentModal,
        showModal,
        hideModal,
        openLoginModal,
        intendedRoute,
        setIntendedRoute,
      }}
    >
      {children}
      {/* Render LoginModal if the current modal type is LOGIN */}
      {currentModal.type === MODAL_TYPES.LOGIN && (
        <LoginModal {...currentModal.props} />
      )}
      {/* Render FeedbackModal if the current modal type is FEEDBACK */}
      {currentModal.type === MODAL_TYPES.FEEDBACK && (
        <FeedbackModal {...currentModal.props} />
      )}
      {currentModal.type === MODAL_TYPES.TRANSPORTSUPPORT && (
        <TransportSupportModal {...currentModal.props} />
      )}
      {/* {currentModal.type === MODAL_TYPES.VIEWHISTORYDETAILS && (
        <ViewHistoryDetailsModal {...currentModal.props} />
      )} */}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
